<template>
  <v-card class="ma-2" :img="$classImages.cardImages[bdoClass]" elevation="20">
    <v-card-title class="white--text text-capitalize">{{bdoClass}}</v-card-title>
    <v-card-text class="display-1 white--text font-weight-medium">{{usagePercentage}}%</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ClassCard",
  props: { bdoClass: String, usagePercentage: String }
};
</script>